<script>
    import {initializeGsapAnimation} from '../../utils';
    import {onMount} from 'svelte';
    let main;
    let ParaDiv;
    let ImageDiv;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation( main, ImageDiv, [{scale: 1, duration: 1}, {scale: 1.2, duration: 1}], 3);
        initializeGsapAnimation( main, ParaDiv, [{y: 0, duration: 1}, {y: '-50vw', duration: 1}], 3);
    }
</script>
<div class="bg" style="" bind:this={main}>
    <div class="bg-wrapper">
        <img id="bg" width="100%" height="100%" src="images/performersMobile/bg.png" alt="" bind:this={ImageDiv}/>
    </div>
    <div class="performers" >
       
        <heading class="h1">
            PERFORMERS
        </heading>
        <div class="para" style="" bind:this={ParaDiv}>
            We are building the future in which you won't have to take multiple
            shots for a single performance, rather based on a myriad performance
            captures, your likeness will be digitized, owned and would be
            perpetually used into any production.
        </div>
    </div>
</div>

<style>
    .bg{
        position: relative;
        background-size: cover;
        height: max(216.355vw, 100.16vh);
        overflow: hidden;
    }
    .bg-wrapper{
        height: max(216.355vw, 100.16vh);
        width:104%;
    }
    .performers {
        font-family: "Orbitron";
        
    }
    .h1 {
        position: absolute;
        top: max(47.196vw, 21.85vh);
        left: -3vw;
        font-size: 13.318vw;
        font-weight: 800;
        line-height: 18.692vw;
        text-align: left;
        color: #67eebb;
    }
    .para{
        position: absolute;
        height: 19.860vw;
        width: 94.159vw;
        left: 3.037vw;
        top: max(172.897vw, 80.04vh);
        color: white;
        font-size: 2.804vw;
        font-weight: 700;
        line-height: 3.972vw;
        letter-spacing: 0.06em;
        text-align: center;

    }
</style>
